import { defineMessages } from 'react-intl';

export const commonMessages = defineMessages({
    'common.calm': {
        id: 'common.calm',
        defaultMessage: 'Calm',
        description: 'Name of the Company',
    },
    'common.access_code_banner.title': {
        id: 'common.access_code_banner.title',
        defaultMessage:
            'Enter the access code provided by your provider, employer or health insurance to proceed.',
        description:
            'Text prompting the user for an access code so they can redeem a sponsorship in the app.',
    },
    'common.access_code_banner.cta': {
        id: 'common.access_code_banner.cta',
        defaultMessage: 'Enter Access Code',
        description:
            'Button text for asking the user to provide an access code.',
    },
    'common.back_home': {
        id: 'common.back_home',
        defaultMessage: 'Back to home',
        description: 'Button text for navigating back to the home page.',
    },
    'common.back_button_label': {
        id: 'common.back_button_label',
        defaultMessage: 'Navigate back',
        description: 'Label for the back navigation button.',
    },
    'common.brand_name': {
        id: 'common.brand_name',
        defaultMessage: 'Calm Health',
        description: 'The name of the Calm Health product.',
    },
    'common.completed_programs': {
        id: 'common.completed_programs',
        defaultMessage: 'Completed Programs',
        description:
            'Series of content that the user has already finished listening to.',
    },
    'common.completed_clinical_programs': {
        id: 'common.completed_clinical_programs',
        defaultMessage: 'Completed Clinical Programs',
        description:
            'Series of clinical content that the user has already finished listening to.',
    },
    'common.devtools.title': {
        id: 'common.devtools.title',
        defaultMessage: 'Dev Tools',
        description: 'Title for the developer tools page.',
    },
    'common.error.not_found.page_header': {
        id: 'common.error.not_found.page_header',
        defaultMessage: '404',
        description: 'Header for the 404 not found page.',
    },
    'common.error.not_found.page_body': {
        id: 'common.error.not_found.page_body',
        defaultMessage: 'Page Not Found',
        description: 'Body for the 404 not found page.',
    },
    'common.error.general.page_header': {
        id: 'common.error.general.page_header',
        defaultMessage: 'Something went wrong',
        description:
            'Header for the general error page, meaning something ocurred on the Calm side which the user cannot recover from.',
    },
    'common.error.general.page_body': {
        id: 'common.error.general.page_body',
        defaultMessage: 'Please try again later.',
        description: 'Text asking the user to perform the same action later.',
    },
    'common.error.error_dialog.title': {
        id: 'common.error.error_dialog.title',
        defaultMessage: 'Something went wrong',
        description:
            'Generic error message, meaning something ocurred on the Calm side which the user cannot recover from.',
    },
    'common.error.error_dialog.support_email': {
        id: 'common.error.error_dialog.support_email',
        defaultMessage: 'support@calmhealth.com',
        description: 'Email at which users should contact Calm Health Support',
    },
    'common.error.error_dialog.description': {
        id: 'common.error.error_dialog.description',
        defaultMessage:
            'We could not complete your request. Please try again later.',
        description:
            'Message explaining to the user that there was an error on the Calm side and they should try again later.',
    },
    'common.error.error_dialog.description_support': {
        id: 'common.error.error_dialog.description_support',
        defaultMessage:
            'We could not complete your request. Please try again later or contact support.',
        description:
            'Message explaining to the user that there was an error on the Calm side and they should try again later or contact support.',
    },
    'common.error.error_dialog.button_text': {
        id: 'common.error.error_dialog.button_text',
        defaultMessage: 'Ok',
        description: 'Button text for closing the dialog.',
    },
    'common.skip_to_main': {
        id: 'common.skip_to_main',
        defaultMessage: 'Skip to main content',
        description:
            'Button text for skipping to the main content of the page.',
    },
    'common.scroll_into_view': {
        id: 'common.scroll_into_view',
        defaultMessage: 'Scroll this content into view',
        description:
            'Button text for scrolling the content into the main viewable area of the page.',
    },
    'common.hide_controls': {
        id: 'common.hide_controls',
        defaultMessage: 'Hide controls',
        description:
            'Button text for making the controls of a video or audio player not viewabe.',
    },
    'common.show_controls': {
        id: 'common.show_controls',
        defaultMessage: 'Show controls',
        description:
            'Button text for making the controls of a video or audio player viewable.',
    },
    'common.view_all': {
        id: 'common.view_all',
        defaultMessage: 'View All',
        description:
            'Button text for viewing all of a specific type of content.',
    },
    'common.view_all_section': {
        id: 'common.view_all_section',
        defaultMessage: 'View All {sectionTitle}',
        description:
            'Accessible name for a "View All" button, including the title of the section it belongs to.',
    },
    'common.all': {
        id: 'common.all',
        defaultMessage: 'All {contentType}',
        description: 'Label for all content of a specific type',
    },
    'common.view_program': {
        id: 'common.view_program',
        defaultMessage: 'View Program',
        description:
            'Button text for viewing the contents of a specific program.',
    },
    'common.view_programs': {
        id: 'common.view_programs',
        defaultMessage: 'View Programs',
        description: 'Button text for viewing programs.',
    },
    'common.view_all_calm_clinical_programs': {
        id: 'common.view_all_calm_clinical_programs',
        defaultMessage: 'View All Calm Clinical Programs',
        description:
            'Button text for viewing all of the Calm Clinical programs.',
    },
    'common.view_all_clinical_programs': {
        id: 'common.view_all_clinical_programs',
        defaultMessage: 'View All Clinical Programs',
        description: 'Button text for viewing all of the clinical programs.',
    },
    allClinicalPrograms: {
        id: 'common.all_clinical_title',
        defaultMessage: 'All Clinical Programs',
        description:
            'Title for the section that lists all of the clinical programs available.',
    },
    exploreClinicalPrograms: {
        id: 'common.explore_clinical_programs',
        defaultMessage:
            'Explore {count, plural, one { {count, number} Calm Health Clinical Program} other {{count, number} Calm Health Clinical Programs}}',
        description: 'A count of clinical programs.',
    },
    'common.programs': {
        id: 'common.programs',
        defaultMessage:
            '{count, plural, one { {count, number} Program} other {{count, number} Programs}}',
        description: 'A count of programs.',
    },
    'common.view_all_recommendations': {
        id: 'common.view_all_recommendations',
        defaultMessage: 'View All Recommendations',
        description: 'Button text for viewing all of the recommendations.',
    },
    viewAllMindshifts: {
        id: 'common.view_all_mindshifts',
        defaultMessage: 'View All Mindshifts',
        description: 'Button text for viewing all of the Mindshift programs.',
    },
    'common.recommendations': {
        id: 'common.recommendations',
        defaultMessage:
            '{count, plural, one { {count, number} Recommendation} other {{count, number} Recommendations}}',
        description: 'A count of recommendations.',
    },
    'common.dismiss_chip': {
        id: 'common.dismiss_chip',
        defaultMessage: 'Dismiss Chip',
        description: 'Button text for dismissing a selectable item chip.',
    },
    'common.dismiss_dialog': {
        id: 'common.dismiss_dialog',
        defaultMessage: 'Dismiss Dialog',
        description: 'Button text for closing a dialog.',
    },
    'common.dismiss_banner': {
        id: 'common.dismiss_banner',
        defaultMessage: 'Dismiss Banner',
        description: 'Button text for closing a banner.',
    },
    'common.dismiss_recommendation_title': {
        id: 'common.dismiss_recommendation_title',
        defaultMessage:
            'How long do you want to dismiss this recommendation for?',
        description:
            'Dialog title for dismissing a recommendation card shown to the user.',
    },
    'common.dismiss_recommendation_subtitle': {
        id: 'common.dismiss_recommendation_subtitle',
        defaultMessage:
            'You can always find this program in Discover All Clinical Programs',
        description:
            'Dialog subtitle for dismissing a recommendation card shown to the user.',
    },
    'common.dismiss_recommendation_cta_snooze': {
        id: 'common.dismiss_recommendation_snooze',
        defaultMessage: 'Snooze for 10 days',
        description:
            'Dialog cta button text for snoozing the recommendation shown.',
    },
    'common.dismiss_recommendation_cta_dismiss': {
        id: 'common.dismiss_recommendation_cta_dismiss_permanently',
        defaultMessage: 'Permanently Dismiss',
        description:
            'Dialog cta button text for permanently dismissing the recommendation shown.',
    },
    'common.dismiss_recommendation.snooze.confirmation.title': {
        id: 'common.dismiss_recommendation.snooze.confirmation.title',
        defaultMessage:
            'Are you sure you would like to snooze this recommended program for 10 days?',
        description: 'Confirmation dialog title for snoozing a recommendation.',
    },
    'common.dismiss_recommendation.dismiss.confirmation.title': {
        id: 'common.dismiss_recommendation.dismiss.confirmation.title',
        defaultMessage:
            'Are you sure you would like to permanently dismiss this recommended program?',
        description:
            'Confirmation dialog title for dismissing a recommendation.',
    },
    'common.dismiss_recommendation_cta_keep': {
        id: 'common.dismiss_recommendation_cta_keep',
        defaultMessage: 'Keep this Recommendation',
        description:
            'Confirmation dialog cta for keeping the recommendation, and closing the dialog.',
    },
    'common.appleAppStore': {
        id: 'common.appleAppStore',
        defaultMessage: 'Download Calm Health for iOS',
        description:
            'Message prompting the user to download the Calm Health app from the Apple App Store.',
    },
    'common.googlePlay': {
        id: 'common.googlePlay',
        defaultMessage: 'Download Calm Health for Android',
        description:
            'Message prompting the user to download the Calm Health app from the Google Play Store.',
    },
    'common.calmAppleAppStore': {
        id: 'common.calmAppleAppStore',
        defaultMessage: 'Download Calm for iOS',
        description:
            'Message prompting the user to download the Calm app from the Apple App Store.',
    },
    'common.calmGooglePlay': {
        id: 'common.calmGooglePlay',
        defaultMessage: 'Download Calm for Android',
        description:
            'Message prompting the user to download the Calm app from the Google Play Store.',
    },
    'common.looking_for_calm_app': {
        id: 'common.looking_for_calm_app',
        defaultMessage: 'Looking for the Calm app?',
        description:
            'Message asking the user if they are instead trying to find the Calm app.',
    },
    'common.form_error_required': {
        id: 'common.form_error_required',
        defaultMessage: 'Error: Required field.',
        description:
            'Form validation error message for when a required field is not filled out.',
    },
    'common.form_error_submission': {
        id: 'common.form_error_submission',
        defaultMessage: 'Error: Unable to submit form',
        description:
            'Form validation error message for when the form cannot be submitted.',
    },
    'common.license': {
        id: 'common.license',
        defaultMessage: 'License {license}',
        description: 'License information.',
    },
    'common.loading': {
        id: 'common.loading',
        defaultMessage: 'Loading',
        description: 'Message indicating that the page is loading.',
    },
    'common.elipsis': {
        id: 'common.elipsis',
        defaultMessage: '...',
        description: 'Elipsis character.',
    },
    'common.login': {
        id: 'common.login',
        defaultMessage: 'Log In',
        description: 'Button text for logging in.',
    },
    'common.logout': {
        id: 'common.logout',
        defaultMessage: 'Log Out',
        description: 'Button text for logging out.',
    },
    'common.logging_out': {
        id: 'common.logging_out',
        defaultMessage: 'Logging Out',
        description: 'Status message indicating that the user is logging out.',
    },
    'common.logo_alt': {
        id: 'common.logo_alt',
        defaultMessage: 'Calm Health Logo',
        description: 'Alternative text for the Calm Health logo.',
    },
    'common.required': {
        id: 'common.required',
        defaultMessage: 'Required',
        description: 'Text indicating that a field is required.',
    },
    'common.open_main_menu': {
        id: 'common.open_main_menu',
        defaultMessage: 'Open Main Menu',
        description: 'Button text for opening the main menu.',
    },
    'common.close_main_menu': {
        id: 'common.close_main_menu',
        defaultMessage: 'Close Main Menu',
        description: 'Button text for closing the main menu.',
    },
    'common.sessions': {
        id: 'common.sessions',
        defaultMessage: '{sessions} Sessions',
        description: 'Number of sessions.',
    },
    'common.tracks': {
        id: 'common.tracks',
        defaultMessage: '{tracks} Tracks',
        description: 'Number of tracks in a music program.',
    },
    'common.session_avg_length': {
        id: 'common.session_avg_length',
        defaultMessage: '{min}-{max} min each',
        description:
            'Average length of sessions, displayed as a range of minutes.',
    },
    'common.clinical_author': {
        id: 'common.clinical_author',
        defaultMessage: 'Clinical Author',
        description: 'The author of a clinical program.',
    },
    'common.author': {
        id: 'common.author',
        defaultMessage: 'Author',
        description: 'The author of a program.',
    },
    'common.narrator': {
        id: 'common.narrator',
        defaultMessage: 'Narrator',
        description: 'The narrator of a program.',
    },
    'common.artist': {
        id: 'common.artist',
        defaultMessage: 'Artist',
        description: 'The artist of a music track, album, or playlist.',
    },
    'common.artist_and_author': {
        id: 'common.artist_and_author',
        defaultMessage: 'Artist & Author',
        description:
            'Combined label when artist and author are the same person.',
    },
    'common.narrator_and_author': {
        id: 'common.narrator_and_author',
        defaultMessage: 'Narrator & Author',
        description:
            'Combined label when narrator and author are the same person.',
    },
    'common.total_sessions': {
        id: 'common.total_sessions',
        defaultMessage: 'Total Sessions',
        description: 'Total number of sessions.',
    },
    'common.session_minutes': {
        id: 'common.session_minutes',
        defaultMessage: 'Session Minutes',
        description: 'Duration of a session.',
    },
    'common.session_minutes_description': {
        id: 'common.session_minutes_description',
        defaultMessage: '{min} - {max} min',
        description: 'Duration of a session.',
    },
    'common.program_type.clinical_program.title': {
        id: 'common.program_type.clinical_program.title',
        defaultMessage: 'Calm Clinical',
        description: 'Indicator that a Calm program is a clinical program.',
    },
    'common.program_type.clinical_program.description': {
        id: 'common.program_type.clinical_program.description',
        defaultMessage:
            'These programs adhere to the principles of Cognitive Behavioral Therapy, Acceptance Commitment Therapy and Dialectical Therapy to provide mental health support for various acuity levels and pre-existing conditions.',
        description:
            'Description of the therapeutic approaches behind the content in these programs.',
    },
    'common.program_type.undefined.title': {
        id: 'common.program_type.undefined.title',
        defaultMessage: 'Calm DTC',
        description:
            'Indicator that a Calm program is a direct-to-consumer program.',
    },
    'common.program_type.undefined.description': {
        id: 'common.program_type.undefined.description',
        defaultMessage: 'The programs are made by Calm to soothe you.',
        description:
            'Description explaining that this content is meant to be calming.',
    },
    'common.added_to_library': {
        id: 'common.added_to_library',
        defaultMessage: 'Added to Your Library',
        description:
            "Message indicating that a piece of content has been added to the user's library.",
    },
    'common.removed_from_library': {
        id: 'common.removed_from_library',
        defaultMessage: 'Removed from Your Library',
        description:
            "Message indicating that a piece of content has been removed from the user's library.",
    },
    'common.added_to_favorites': {
        id: 'common.added_to_favorites',
        defaultMessage: 'Added to Your Favorites',
        description:
            "Message indicating that a piece of content has been added to the user's favorites.",
    },
    'common.removed_from_favorites': {
        id: 'common.removed_from_favorites',
        defaultMessage: 'Removed from Your Favorites',
        description:
            "Message indicating that a piece of content has been removed from the user's favorites.",
    },
    'common.view_details': {
        id: 'common.view_details',
        defaultMessage: 'View Details',
        description:
            'Button text for viewing the details of a piece of content.',
    },
    'common.play_trailer': {
        id: 'common.play_trailer',
        defaultMessage: 'Play Trailer',
        description:
            'Button text for playing a trailer for a piece of content.',
    },
    'common.play_session': {
        id: 'common.play_session',
        defaultMessage: 'Play Session',
        description: 'Button text for playing a session.',
    },
    'common.play_next_session': {
        id: 'common.play_next_session',
        defaultMessage: 'Play Next Session',
        description: 'Button text for playing the next session.',
    },
    'common.play_session_number': {
        id: 'common.play_session_number',
        defaultMessage: 'Play Session {number}',
        description: 'Button text for playing a specific session.',
    },
    'common.play_session_number_title': {
        id: 'common.play_session_number_title',
        defaultMessage: 'Play Session {number}: {title}',
        description: 'Button text for playing a specific session.',
    },
    'common.play_session_number_title_duration': {
        id: 'common.play_session_number_title_duration',
        defaultMessage: 'Play Session {number}: {title}. Duration {duration}',
        description: 'Button text for playing a specific session.',
    },
    'common.of': {
        id: 'common.of',
        defaultMessage: '{numerator} of {denominator}',
        description:
            'Text explaining the position of a piece of content within a series. Example: 1 of 10.',
    },
    'common.buffer_of': {
        id: 'common.buffer_of',
        defaultMessage: 'buffer {numerator} of {denominator}',
        description:
            'Text explaining the position of a piece of content within a series. Example: 1 of 10.',
    },
    'common.session_of': {
        id: 'common.session_of',
        defaultMessage: 'Session {numerator} of {denominator}',
        description:
            'Text explaining the position of a piece of content within a series. Example: 1 of 10.',
    },
    'common.new': {
        id: 'common.new',
        defaultMessage: 'New',
        description: 'Indicator that a piece of content is new.',
    },
    'common.hrs': {
        id: 'common.hrs',
        defaultMessage: '{hours} hrs',
        description:
            'Duration of a piece of content in hours. Uses an abbreviation for hours.',
    },
    'common.min': {
        id: 'common.min',
        defaultMessage: '{minutes} min',
        description:
            'Duration of a piece of content in minutes. Uses an abbreviation for minutes.',
    },
    'common.sec': {
        id: 'common.sec',
        defaultMessage: '{seconds} sec',
        description:
            'Duration of a piece of content in seconds. Uses an abbreviation for seconds.',
    },
    'common.favorite_with_title': {
        id: 'common.favorite_with_title',
        defaultMessage: 'Favorite {title}',
        description:
            'Text for taking the action of marking a piece of content as a favorite.',
    },
    'common.favorite_no_title': {
        id: 'common.favorite_no_title',
        defaultMessage: 'Favorite',
        description:
            'Text for taking the action of marking a piece of content as a favorite.',
    },
    'common.favorites': {
        id: 'common.favorites',
        defaultMessage: 'Favorites',
        description:
            "Text for a section of the app that contains the user's favorite content.",
    },
    'common.unfavorite': {
        id: 'common.unfavorite',
        defaultMessage: 'Unfavorite {title}',
        description:
            "Text for taking the action of removing a piece of content from the user's favorites.",
    },
    'common.unfavorite_no_title': {
        id: 'common.unfavorite_no_title',
        defaultMessage: 'Unfavorite',
        description:
            "Text for taking the action of removing a piece of content from the user's favorites.",
    },
    'common.completed': {
        id: 'common.completed',
        defaultMessage: 'Completed {title}',
        description: 'Text for when a piece of content is marked as completed.',
    },
    'common.locked': {
        id: 'common.locked',
        defaultMessage: 'Locked {title}',
        description:
            'Text for when a piece of content is locked and cannot be played.',
    },
    'common.play': {
        id: 'common.play',
        defaultMessage: 'Play {title}',
        description: 'Button text for playing a piece of content.',
    },
    'common.now_playing': {
        id: 'common.now_playing',
        defaultMessage: 'Now playing {title}',
        description:
            'Screen-reader label announcing which track is currently playing.',
    },
    'common.paused_track': {
        id: 'common.paused_track',
        defaultMessage: 'Paused {title}',
        description:
            'Screen-reader label for the active track row when playback is paused.',
    },
    'common.simple_play': {
        id: 'common.simple_play',
        defaultMessage: 'Play',
        description: 'Simple play button text.',
    },
    'common.percent_complete': {
        id: 'common.percent_complete',
        defaultMessage: '{percentage} percent complete',
        description:
            'Text describing the percentage of a piece of content that has been completed.',
    },
    'common.toc': {
        id: 'common.toc',
        defaultMessage: 'Terms of Service',
        description: 'Terms of Service',
    },
    'common.privacy_policy': {
        id: 'common.privacy_policy',
        defaultMessage: 'Privacy Policy',
        description: 'Privacy Policy',
    },
    'common.continue': {
        id: 'common.continue',
        defaultMessage: 'Continue',
        description: 'Button text for continuing.',
    },
    'common.confirm': {
        id: 'common.confirm',
        defaultMessage: 'Confirm',
        description: 'Button text for confirming an action.',
    },
    'common.save': {
        id: 'common.save',
        defaultMessage: 'Save',
        description: 'Button text for saving selections on a form.',
    },
    'common.submit': {
        id: 'common.submit',
        defaultMessage: 'Submit',
        description: 'Button text for submitting a form.',
    },
    'common.skip': {
        id: 'common.skip',
        defaultMessage: 'Skip',
        description: 'Button text for skipping a step.',
    },
    'common.reset': {
        id: 'common.reset',
        defaultMessage: 'Reset',
        description: 'Button text for resetting a form.',
    },
    'common.remove': {
        id: 'common.remove',
        defaultMessage: 'Remove {item}',
        description: 'Label for a button to remove an item',
    },
    'common.reset_successful': {
        id: 'common.reset_successful',
        defaultMessage: 'Reset successful',
        description:
            'Snackbar that shows when the user successfully resets something',
    },
    'common.topics_saved': {
        id: 'common.topics_saved',
        defaultMessage: 'Topics saved successfully',
        description:
            "Screen-reader status message announcing that the user's topic selections were saved. WCAG 4.1.3 Status Messages.",
    },
    'common.removed_item_from_selection': {
        id: 'common.removed_item_from_selection',
        defaultMessage: 'Removed "{item}" from selection',
        description:
            'Screen-reader status message announcing that an item was removed from a selection. WCAG 4.1.3 Status Messages.',
    },
    'common.recently_played': {
        id: 'common.recently_played',
        defaultMessage: 'Recently Played',
        description:
            "Section of the app that contains the user's recently played content.",
    },
    'common.done': {
        id: 'common.done',
        defaultMessage: 'Done',
        description: 'Button text for when the user has finished an action.',
    },
    'common.summary': {
        id: 'common.summary',
        defaultMessage: 'Summary',
        description: 'Button text for viewing a summary of a piece of content.',
    },
    'common.close': {
        id: 'common.close',
        defaultMessage: 'Close',
        description: 'Button text for closing a dialog.',
    },
    'common.cancel': {
        id: 'common.cancel',
        defaultMessage: 'Cancel',
        description: 'Button text for canceling an action.',
    },
    'common.schedule': {
        id: 'common.schedule',
        defaultMessage: 'Schedule',
        description: 'Button text for viewing the scheduling of a program.',
    },
    'common.overview': {
        id: 'common.overview',
        defaultMessage: 'Overview',
        description:
            'Text for a section of the app that contains an overview of a piece of content.',
    },
    'common.take_survey': {
        id: 'common.take_survey',
        defaultMessage: 'Take the {title}',
        description: 'Button text for taking a survey.',
    },
    'common.retake_survey': {
        id: 'common.retake_survey',
        defaultMessage: 'Retake the {title}',
        description: 'Button text for retaking a survey.',
    },
    'common.looking_for_calm': {
        id: 'common.looking_for_calm',
        defaultMessage:
            'You can also try Calm, the #1 app for sleep and meditation.',
        description: 'Message suggesting that the user try the Calm app.',
    },
    'common.download': {
        id: 'common.download',
        defaultMessage: 'Download',
        description: 'Button text for downloading a document.',
    },
    'common.download_calm_health': {
        id: 'common.download_calm_health',
        defaultMessage: 'Download the Calm Health Mobile App',
        description: 'Button text for downloading the Calm Health app.',
    },
    'common.delete': {
        id: 'common.delete',
        defaultMessage: 'Delete',
        description: 'Button text for deleting a piece of content.',
    },
    'common.back': {
        id: 'common.back',
        defaultMessage: 'Back',
        description: 'Button text for navigating back.',
    },
    'common.forward': {
        id: 'common.forward',
        defaultMessage: 'Forward',
        description: 'Button text for navigating forward.',
    },
    'common.carousel_position_status': {
        id: 'common.carousel_position_status',
        defaultMessage: 'Showing item {current} of {total}',
        description:
            'Screen-reader status message announcing the carousel position after the back/forward buttons are activated. WCAG 4.1.3 Status Messages.',
    },
    'common.previous': {
        id: 'common.previous',
        defaultMessage: 'Previous',
        description: 'Button text for navigating to the previous item.',
    },
    'common.next': {
        id: 'common.next',
        defaultMessage: 'Next',
        description: 'Button text for navigating to the next item.',
    },
    'common.page.discover': {
        id: 'common.page.discover',
        defaultMessage: 'Discover',
        description: 'Header for the discover page',
    },
    'common.page.health': {
        id: 'common.page.health',
        defaultMessage: 'Health',
        description: 'Header for the health page',
    },
    'common.page.home': {
        id: 'common.page.home',
        defaultMessage: 'Home',
        description: 'Header for the home page',
    },
    'common.page.careplan': {
        id: 'common.page.careplan',
        defaultMessage: 'Plan',
        description: 'Header for the care plan page',
    },
    'common.page.profile': {
        id: 'common.page.profile',
        defaultMessage: 'Profile',
        description: 'Header for the profile page',
    },
    'common.items_require_attention': {
        id: 'common.items_require_attention',
        defaultMessage:
            '{count, plural, one { There is an item that requires your attention } other {There are {count, number} items that require your attention }}',
        description:
            'Message indicating that there are items that the user needs to fix before they can proceed.',
    },
    'common.clear': {
        id: 'common.clear',
        defaultMessage: 'Clear',
        description: 'Button text for clearing a form.',
    },
    'common.yes': {
        id: 'common.yes',
        defaultMessage: 'Yes',
        description: 'Affirmative response.',
    },
    'common.ok': {
        id: 'common.ok',
        defaultMessage: 'Ok',
        description: 'Button text for confirming an action.',
    },
    'common.no': {
        id: 'common.no',
        defaultMessage: 'No',
        description: 'Negative response.',
    },
    'common.meet': {
        id: 'common.meet',
        defaultMessage: 'Meet {name}',
        description: 'Text introducing the user to a new person.',
    },
    'common.qr_code': {
        id: 'common.qr_code',
        defaultMessage: 'QR code for {url}',
        description: 'Text explaining that a QR code is for a specific URL.',
    },
    'common.scan_qr_code': {
        // Keeps the id the locale files already translate.
        id: 'qrCodeDialog.scanQrCode',
        defaultMessage:
            'Scan the QR code with your camera to download our free app now for exclusive mobile features and faster access.',
        description:
            'Message prompting the user to scan the QR code to download the Calm Health app from the their device app store.',
    },
    'common.copyright': {
        id: 'common.copyright',
        defaultMessage: 'Copyright © {year} Calm. All Rights Reserved.',
        description: 'Copyright information.',
    },
    'common.version': {
        id: 'common.version',
        defaultMessage: 'Version: {version}',
        description: 'Version information.',
    },
    'common.open': {
        id: 'common.open',
        defaultMessage: 'Open {name}',
        description: 'Button text for opening a piece of content.',
    },
    'common.tool': {
        id: 'common.tool',
        defaultMessage: 'Tool {name}',
        description: 'Button text for opening a tool.',
    },
    'common.results': {
        id: 'common.results',
        defaultMessage:
            '{count, plural, one { 1 Result } other {{count, number} Results }}',
        description: 'Results.',
    },
    'common.linear_graph': {
        id: 'common.linear_graph',
        defaultMessage: '{valueLabel}: {value} on a scale of {min} to {max}',
        description: 'Text describing a linear graph.',
    },
    'common.graph_info': {
        id: 'common.graph_info',
        defaultMessage: 'Information about the {title} chart',
        description: 'Information about a chart.',
    },
    'common.today': {
        id: 'common.today',
        defaultMessage: 'Today',
        description: 'Header for a tab describing the present day',
    },
    'common.yesterday': {
        id: 'common.yesterday',
        defaultMessage: 'Yesterday',
        description: 'Header for a tab describing the previous day',
    },
    'common.tomorrow': {
        id: 'common.tomorrow',
        defaultMessage: 'Tomorrow',
        description: 'Header for a tab describing the next day',
    },
    'common.personalizing_care_plan': {
        id: 'common.personalizing_care_plan',
        defaultMessage: 'Personalizing your Plan',
        description:
            "Text to display while the user's care plan is being created based on the information they provided.",
    },
    'common.updating_care_plan': {
        id: 'common.updating_care_plan',
        defaultMessage: 'Updating your Plan',
        description:
            "Text to display while the user's care plan is being updated based on the information they provided.",
    },
    'common.ftue_step.goals': {
        id: 'common.ftue_step.goals',
        defaultMessage: 'Goals',
        description: 'Header for the goals step in the FTUE.',
    },
    'common.ftue_step.topics': {
        id: 'common.ftue_step.topics',
        defaultMessage: 'Topics',
        description: 'Header for the topics step in the FTUE.',
    },
    'common.ftue_step.conditions': {
        id: 'common.ftue_step.conditions',
        defaultMessage: 'Conditions',
        description: 'Header for the conditions step in the FTUE.',
    },
    'common.ftue_step.screening': {
        id: 'common.ftue_step.screening',
        defaultMessage: 'Screening',
        description: 'Header for the mental health screening step in the FTUE.',
    },
    'common.more_menu_options': {
        id: 'common.more_menu_options',
        defaultMessage: 'More Menu Options',
        description: 'Button text for viewing more menu options.',
    },
    getStarted: {
        id: 'common.more_options.get_started',
        defaultMessage: 'Get Started',
        description: 'Button text for getting started.',
    },
    'common.more_options.learn_more': {
        id: 'common.more_options.learn_more',
        defaultMessage: 'Learn More',
        description:
            'Button text for viewing more information about a program.',
    },
    'common.more_options.skip_this_month': {
        id: 'common.more_options.skip_this_month',
        defaultMessage: 'Skip This Month',
        description: 'Button text for skipping a month of a program.',
    },
    'common.more_options.video_overview': {
        id: 'common.more_options.video_overview',
        defaultMessage: 'Video Overview',
        description: 'Button text for viewing a video overview of a program.',
    },
    'common.audio_player': {
        id: 'common.audio_player',
        defaultMessage: 'Audio Player',
        description:
            'Text indicating that the user is viewing an audio player.',
    },
    'common.audio_description': {
        id: 'common.audio_description',
        defaultMessage: 'Audio description',
        description:
            'Accessibility label for the description text region of an audio player.',
    },
    'common.video_player': {
        id: 'common.video_player',
        defaultMessage: 'Video Player',
        description: 'Text indicating that the user is viewing a video player.',
    },
    'common.top_recommendation': {
        id: 'common.top_recommendation',
        defaultMessage: 'Top Recommendation',
        description:
            'Text indicating that a piece of content is the top recommendation.',
    },
    'common.dismiss': {
        id: 'common.dismiss',
        defaultMessage: 'Dismiss',
        description:
            'Button and menu item text for removing a recommendation from the home carousel.',
    },
    'common.browse_by_goal': {
        id: 'common.browse_by_goal',
        defaultMessage: 'Browse by Goal',
        description: 'Button text for browsing content by goal.',
    },
    'common.goal.increase-happiness': {
        id: 'common.goal.increase-happiness',
        defaultMessage: 'Increase Happiness',
        description: 'Goal to increase happiness.',
    },
    'common.goal.sleep-better': {
        id: 'common.goal.sleep-better',
        defaultMessage: 'Sleep Better',
        description: 'Goal to sleep better.',
    },
    'common.goal.develop-gratitude': {
        id: 'common.goal.develop-gratitude',
        defaultMessage: 'Develop Gratitude',
        description: 'Goal to develop gratitude.',
    },
    'common.goal.build-self-esteem': {
        id: 'common.goal.build-self-esteem',
        defaultMessage: 'Build Self Esteem',
        description: 'Goal to build self esteem.',
    },
    'common.goal.reduce-anxiety': {
        id: 'common.goal.reduce-anxiety',
        defaultMessage: 'Reduce Anxiety',
        description: 'Goal to reduce anxiety.',
    },
    'common.goal.improve-performance': {
        id: 'common.goal.improve-performance',
        defaultMessage: 'Improve Performance',
        description: 'Goal to improve performance.',
    },
    'common.goal.reduce-stress': {
        id: 'common.goal.reduce-stress',
        defaultMessage: 'Reduce Stress',
        description: 'Goal to reduce stress.',
    },
    'common.view_your_profile': {
        id: 'common.view_your_profile',
        defaultMessage: 'View Your Profile',
        description: "Button text for viewing the user's profile.",
    },
    'common.update_your_mental_health_screening': {
        id: 'common.update_your_mental_health_screening',
        defaultMessage: "Let's check in on your mental health",
        description:
            "Button text for updating the user's mental health screening.",
    },
    'common.update_your_goals': {
        id: 'common.update_your_goals',
        defaultMessage: 'Let’s identify your goals',
        description: "Button text for updating the user's goals.",
    },
    'common.screening_goals_topics_conditions': {
        id: 'common.screening_goals_topics_conditions',
        defaultMessage: 'Mental Health Screening, Goals, Topics and Conditions',
        description:
            'Text indicating that the user is viewing the mental health screening, goals, topics, and conditions.',
    },
    goalsAndTopics: {
        id: 'common.goals_topics',
        defaultMessage: 'Goals and Topics',
        description:
            'Text indicating that the user is viewing the goals and topics.',
    },
    'common.todays_daily': {
        id: 'common.todays_daily',
        defaultMessage: 'Today’s {dailyType}',
        description:
            "Text indicating that the user is viewing today's daily content of a certain type.",
    },
    mentalHealthScreeningRetriggerTitle: {
        id: 'common.screening_retrigger_banner_title',
        defaultMessage: 'It’s time for your next mental health check-in',
        description:
            'Text prompting the user to take a mental health screening.',
    },
    mentalHealthScreeningRetriggerSubtitle: {
        id: 'common.screening_retrigger_banner_subtitle',
        defaultMessage: 'You are due for your monthly mental health screening.',
        description:
            'Text prompting the user to take a mental health screening.',
    },
    'common.screening_retrigger_banner_title_v2': {
        id: 'common.screening_retrigger_banner_title_v2',
        defaultMessage: 'Check in on your mental health',
        description:
            'Text prompting the user to take a mental health screening.',
    },
    'common.screening_retrigger_banner_cta': {
        id: 'common.screening_retrigger_banner_cta',
        defaultMessage: 'Take the Mental Health Screening',
        description: 'Button text for taking a mental health screening.',
    },
    'common.screening_banner_title': {
        id: 'common.screening_banner_title',
        defaultMessage: 'Let’s check in on your mental health',
        description:
            'Text prompting the user to take a mental health screening.',
    },
    'common.screening_banner_subtitle': {
        id: 'common.screening_banner_subtitle',
        defaultMessage:
            'This allows us to better to personalize your Plan for you.',
        description:
            'Text explaining why the user should take a mental health screening.',
    },
    mhsV3CardTitle: {
        id: 'common.screening_banner_v3_title',
        defaultMessage: 'Check in on your mental health',
        description:
            'Text prompting the user to take a mental health screening.',
    },
    mhsV3CardSubtitle: {
        id: 'common.screening_banner_v3_subtitle',
        defaultMessage:
            'Taking the mental health screening is the first step to evaluating your whole health.',
        description:
            'Text explaining why the user should take a mental health screening.',
    },
    'common.start_screening': {
        id: 'common.start_screening',
        defaultMessage: 'Start Screening',
        description: 'Button text for starting a mental health screening.',
    },
    takeTheScreening: {
        id: 'common.take_the_screening',
        defaultMessage: 'Take The Screening',
        description: 'Button text for taking a mental health screening.',
    },
    'common.hero_image': {
        id: 'common.hero_image',
        defaultMessage:
            'Jasper Lake in Jasper National Park, Alberta, Canada, surrounded by snow-capped mountains and lush forests.',
        description: 'Description of the hero image.',
    },
    'common.saml_in_progress': {
        id: 'common.saml_in_progress',
        defaultMessage: 'SAML Login In Progress',
        description:
            'Text indicating that the user is in the process of logging in with SAML.',
    },
    'common.results_disclaimer': {
        id: 'common.results_disclaimer',
        defaultMessage:
            'These results, and the use of Calm Health, are not intended to diagnose or treat depression, anxiety, or any other mental or physical health condition. These results, and the use of Calm Health, are not a substitute for care by a physician or other health care provider. Any questions that you may have regarding these results or the diagnosis, care, or treatment of a health condition should be directed to your physician or health care provider. Calm Health is a mental wellness product.',
        description:
            'Text explaining that the results are not a substitute for care by a physician.',
    },
    'common.clinical_disclaimer': {
        id: 'common.clinical_disclaimer',
        defaultMessage:
            'Calm Health is not intended to diagnose or treat depression, anxiety, or any other mental or physical health condition. The use of Calm Health is not a substitute for care by a physician or other health care provider. Any questions that you may have regarding the diagnosis, care, or treatment of a health condition should be directed to your physician or health care provider. Calm Health is a mental wellness product. Individuals under the age of 13 are not permitted to use Calm Health.',
        description:
            'Text explaining that Calm Health is not a substitute for care by a physician.',
    },
    'common.sponsor': {
        id: 'common.sponsor',
        defaultMessage: 'Sponsor',
        description:
            "The person or organization that is sponsoring the user's access to Calm Health.",
    },
    'common.update_sponsor': {
        id: 'common.update_sponsor',
        defaultMessage: 'Update Sponsor',
        description: "Button text for updating the user's sponsor.",
    },
    'common.delete_account': {
        id: 'common.delete_account',
        defaultMessage: 'Delete Account',
        description: "Button text for deleting the user's account.",
    },
    'common.this_week': {
        id: 'common.this_week',
        defaultMessage: 'This Week',
        description: 'Date label for this week',
    },
    'common.last_week': {
        id: 'common.last_week',
        defaultMessage: 'Last Week',
        description: 'Date label for last week',
    },
    'common.this_weeks': {
        id: 'common.this_weeks',
        defaultMessage: "This Week's {weekly}",
        description: "Ex. This Week's Mindshift, This Week's Story",
    },
    'common.last_weeks': {
        id: 'common.last_weeks',
        defaultMessage: "Last Week's {weekly}",
        description: "Ex. Last Week's Mindshift, Last Week's Story",
    },
    showActions: {
        id: 'common.show_actions',
        defaultMessage: 'Show Actions',
        description: 'aria Label for an actions menu',
    },
    'common.or': {
        id: 'common.or',
        defaultMessage: 'or',
        description: 'Text for the word "or"',
    },
    commonBeta: {
        id: 'common.beta',
        defaultMessage: 'Beta',
        description: 'Label indicating that a feature is in beta.',
    },
    freeResponsePlaceholderText: {
        id: 'common.free_response_placeholder_text',
        defaultMessage: 'Answer In Your Own Words...',
        description: 'Placeholder text for a free response question.',
    },
    poweredByAi: {
        id: 'common.powered_by_ai',
        defaultMessage: 'Powered by AI',
        description: 'Text indicating that the feature is powered by AI',
    },
});

export default commonMessages;
